<script>
  import { createEventDispatcher } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let show = false;

  const dispatch = createEventDispatcher();
</script>

<Modal bind:isOpen={show} size="lg" fullscreen="lg">
  <ModalBody class="template-selection-modal modal--content">
    <button class="close" data-testid="close-modal" on:click={() => (show = false)}>
      <Icon name="x" />
    </button>

    <div>
      <h1>{$format('label.NEW_SIGNATURE')}</h1>
      <p>{$format('label.DESCRIPTION.NEW_SIGNATURE')}</p>
    </div>
    <div class="options">
      <button id="blank-sig" data-testid="blank-sig" on:click={() => dispatch('blank')}>
        <div>
          <Icon name="file" />
          <b>{$format('label.BLANK_SIGNATURE')}</b>
        </div>
        <p>{$format('label.DESCRIPTION.BLANK_SIGNATURE')}</p>
      </button>
      <button id="sig-template" data-testid="sig-template" on:click={() => dispatch('template')}>
        <div>
          <Icon name="grid" />
          <b>{$format('label.USE_TEMPLATE')}</b>
        </div>
        <p>{$format('label.DESCRIPTION.USE_TEMPLATE')}</p>
      </button>
      <button id="os-design" data-testid="os-design" on:click={() => window.open('mailto:help@opensense.com')}>
        <div>
          <Icon name="smile" />
          <b>{$format('label.HAVE_US_DESIGN')}</b>
        </div>
        <p>{$format('label.DESCRIPTION.HAVE_US_DESIGN')}</p>
      </button>
    </div>

    <hr />

    <div class="note">
      <b>{$format('label.DID_YOU_KNOW')}</b>
      <p>
        {@html $format('label.DESCRIPTION.DID_YOU_KNOW')}
      </p>
    </div>
  </ModalBody>
  <ModalFooter />
</Modal>
